<template>
  <!--
      作者 rj.wu
      时间：2021-02-01
      描述：会员-佣金明细
  -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="佣金明细" name="log"></el-tab-pane>
      <el-tab-pane label="佣金流水" name="capital"></el-tab-pane>
      <el-tab-pane v-if="show_regionlog" label="区域佣金明细" name="region_log"></el-tab-pane>
    </el-tabs>

    <!--佣金记录表明细-->
    <Log v-if="activeName == 'log'"></Log>
    <Capital v-if="activeName == 'capital'"></Capital>
    <Regionlog v-if="activeName == 'region_log'"></Regionlog>

  </div>
</template>
<script>
import Log from './part/Log';
import Regionlog from './part/Regionlog';
import Capital from './part/Capital';
export default {
  components: {
    Log,Regionlog,Capital
  },
  data() {
    return {
      show_regionlog:true,
      form: {
        status: 0
      },
      activeName: 'log'
    };
  },
  created(){
    if(!this.$filter.isAuth('/user/agentlog/regionlog')) this.show_regionlog = false;
  },
  methods: {}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/user/agent/index.vue